import React from 'react';
import * as Lucide from 'lucide-react';

interface IconPickerProps {
    onSelect: (icon: string) => void;
    onClose: () => void;
}

const ICONS = [
    // Paragliding & Aviation & Nature
    'Wind', 'Plane', 'PlaneTakeoff', 'PlaneLanding', 'Compass', 'Cloud', 'CloudSun', 'CloudRain', 'CloudLightning', 'Sun', 'Sunrise', 'Sunset', 'Mountain', 'Trees', 'Tent', 'Flame', 'Thermometer', 'Bird',

    // Maps & Navigation
    'Map', 'MapPin', 'Globe', 'Route', 'Navigation', 'Flag', 'Milestone', 'Satellite', 'Train', 'Locate',

    // Analysis & Data
    'BarChart', 'LineChart', 'PieChart', 'Activity', 'TrendingUp', 'Gauge', 'Clipboard', 'FileText', 'Search', 'Lightbulb', 'Brain', 'Target', 'Ruler', 'Timer', 'Clock', 'Scale',

    // IT & UI & Tech
    'Laptop', 'Monitor', 'Smartphone', 'Watch', 'Save', 'Settings', 'Wrench', 'Hammer', 'Lock', 'Unlock', 'Shield', 'Key', 'Zap', 'Battery', 'Plug', 'Radio', 'Tv', 'Bell', 'Edit', 'Trash2', 'Folder', 'Upload', 'Download', 'ShoppingCart', 'CreditCard',

    // Communication & User
    'MessageSquare', 'MessageCircle', 'Megaphone', 'Phone', 'Mail', 'Send', 'Handshake', 'Users', 'User', 'UserCheck', 'Heart', 'ThumbsUp', 'ThumbsDown', 'Share2', 'Video', 'Clapperboard', 'Camera', 'Music', 'Mic', 'Headphones',

    // Abstract & Awards & Status
    'Sparkles', 'Star', 'Award', 'Trophy', 'Rocket', 'Gift', 'Puzzle', 'CheckCircle', 'XCircle', 'AlertCircle', 'AlertTriangle', 'Info', 'Gem'
];

export const IconPicker: React.FC<IconPickerProps> = ({ onSelect, onClose }) => {
    return (
        <div className="absolute z-[1000] p-6 bg-slate-900 border border-white/10 rounded-3xl shadow-2xl animate-in fade-in zoom-in-95 min-w-[360px]" onClick={e => e.stopPropagation()}>
            <div className="flex justify-between items-center mb-5">
                <h4 className="text-sm font-bold text-slate-400 uppercase tracking-wider">Icon wählen</h4>
                <button onClick={onClose} className="text-slate-500 hover:text-white p-2 transition-colors">✕</button>
            </div>
            <div className="grid grid-cols-6 gap-2.5 max-h-[350px] overflow-y-auto custom-scrollbar p-1">
                {ICONS.map((iconName, i) => {
                    const IconComponent = (Lucide as any)[iconName];
                    return (
                        <button
                            key={i}
                            onClick={() => onSelect(`<${iconName} className="w-4 h-4 inline mr-1" />`)}
                            className="w-11 h-11 flex items-center justify-center bg-slate-950/40 hover:bg-emerald-500/10 text-slate-400 hover:text-emerald-400 rounded-xl transition-all duration-200 border border-white/5 hover:border-emerald-500/30 hover:scale-105 active:scale-95"
                            title={iconName}
                        >
                            {IconComponent ? <IconComponent className="w-5 h-5" /> : <span className="text-xs">{iconName.substring(0, 2)}</span>}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

